import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { Tooltip } from "recharts";

import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps } from "../../redux/report/agent";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class AgentReportOutbound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      date: null,
    };
  }
  componentDidMount() {
    this.history = globalHistory();
    // this.unlisten = this.history.listen(() => {
    //     this.itemInit();
    // })

    this.itemInit();
  }

  listCollumns = [
    { id: "hour", numeric: true, disablePadding: false, label: "Giờ" },
    {
      id: "total",
      numeric: true,
      disablePadding: true,
      label: "Tổng số cuộc gọi",
    },
    {
      id: "answeredCalls",
      numeric: true,
      disablePadding: true,
      label: "Cuộc gọi nghe máy",
    },
    {
      id: "talkingTime",
      numeric: true,
      disablePadding: true,
      label: "Thời lượng nghe máy",
    },
    { id: "acd", numeric: true, disablePadding: false, label: "ACD" },
  ];

  itemInit() {
    const date = this.props.match.params.date;
    const agentId = this.props.match.params.agentId;
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "agentId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListAgent(filters.order, 999, filters.page, null);
  }

  // componentWillUnmount() {
  //     this.unlisten();
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.reportAgentByDate != this.props.reportAgentByDate) {
      const { date } = this.props.reportAgentByDate;
      this.setState({
        date,
      });
    }
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState({ disable: false });
    this.props.getListReportAgentByHour(
      filters.where.agentId,
      datetimeHelper.toFormat(
        this.state.filters.where.gte,
        "YYYY-MM-DD startDay"
      )
    );
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleChange = (e, value) => {
    this.setState({ value });
  };

  render() {
    const { filters, date, value } = this.state;
    const { classes, reportAgentByHour, listAgents } = this.props;
    const reportAgentByHourResult =
      typeof reportAgentByHour === "object"
        ? Object.keys(reportAgentByHour).map((key) => reportAgentByHour[key])
        : reportAgentByHour;
    const dataReport = [["Giờ", "Nghe máy"]];
    const listAgentsResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    for (const key in reportAgentByHourResult) {
      if (reportAgentByHourResult.hasOwnProperty(key)) {
        const value = reportAgentByHourResult[key];
        dataReport.push([value.hour, value.answeredCalls]);
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Mã nhân viên"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.agentId}
                          name="agentId"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}>
                          {listAgentsResult
                            ? listAgentsResult.map((item, key) => {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.code}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {reportAgentByHour.length != 0 ? (
          <Grid container spacing={24}>
            <Grid item md={12}>
              <Paper
                style={{
                  justifyContent: "center",
                  display: "flex",
                  backgroundColor: "#fff",
                  color: "#000",
                }}>
                <Chart
                  width={"95%"}
                  height={"600px"}
                  chartType="LineChart"
                  loader={<div>Loading Chart</div>}
                  data={dataReport}
                  options={{
                    hAxis: {
                      title: "Thời gian (Giờ)",
                    },
                    vAxis: {
                      title: "Số lượng",
                    },
                    series: {
                      1: { curveType: "function" },
                    },
                  }}
                  rootProps={{ "data-testid": "3" }}
                />
              </Paper>
            </Grid>
          </Grid>
        ) : null}
        <TableData
          {...this.props}
          nameTable="Danh sách báo cáo năng xuất điện thoại viên theo giờ"
          items={reportAgentByHourResult}
          rowsPerPage={filters.pageSize}
          count={reportAgentByHourResult.length}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={false}
          pagination={false}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
  }
}

AgentReportOutbound.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  reportAgentByHour: state.reportAgent.reportAgentByHour,
  reportAgentByDate: state.reportAgent.reportAgentByDate,
  agentReportDetail: state.reportAgent.reportDetail,
  listAgents: state.agent.agents,
});

AgentReportOutbound = connect(
  mapStateToProps,
  mapActionsToProps
)(AgentReportOutbound);
const Agent = connect(null, agentAction)(AgentReportOutbound);
export default withStyles(styles)(Agent);
